module.exports = "pegasus/assets/theme6/twitter-icon.png";